export const highLightRetailCoef = (coefficient) => {
  const mp = Number(coefficient);
  if (mp > 0.99 && mp <= 1.99) return "light-blue";
  if (mp > 1.99 && mp <= 4.99) return "blue";
  if (mp > 4.99 && mp <= 9.99) return "green";
  if (mp > 9.99 && mp <= 49.99) return "yellow";
  if (mp > 49.99 && mp <= 99.99) return "orange";
  if (mp > 99.99) return "red";
  return "win-small";
}